import { Hex, parseAbi, PublicClient } from "viem";
import { accountAbi } from "../common";

export enum MODULE_TYPE {
    VALIDATOR = '0x01',
    EXECUTOR = '0x02',
    FALLBACK = '0x03',
    HOOK = '0x04',
}

export const isModuleInstalled = async (publicClient: PublicClient, etherspotWalletAddress: string, moduleTypeId: MODULE_TYPE, module: string, initData = '0x'): Promise<boolean> => {
    const response = await publicClient.readContract({
        address: etherspotWalletAddress as Hex,
        abi: parseAbi(accountAbi),
        functionName: 'isModuleInstalled',
        args: [moduleTypeId, module, initData]
    });
    return response as boolean;
}